/**
 * Clamp a number to the [0, 1] range. Used by slice position, slider drag,
 * agent-set values, and anywhere else a normalized fraction needs guarding.
 *
 * NaN inputs return 0 (Math.min/Math.max propagate NaN otherwise — caller
 * usually wants a safe default, not a poison value).
 */
export function clamp01(v: number): number {
  if (Number.isNaN(v)) return 0;
  return Math.max(0, Math.min(1, v));
}
